import image1 from "../assets/templates/1.jpg";
import image2 from "../assets/templates/2.jpg";
import image3 from "../assets/templates/3.jpg";
import image4 from "../assets/templates/4.jpg";

import lawyerHub from "../assets/templates/lawyerHub.png";
import clotheShop from "../assets/templates/clotheShop.png";
import carShop from "../assets/templates/carShop.png";
import constructor from "../assets/templates/constructor.png";

export const templatesArray = [
    {
        title: "Lawyer Hub",
        laptopImage: image1,
        image: lawyerHub,
        link: "https://lawyerhub.netlify.app/",
        description: "Place where you can rent the attorney for any kind of purposes or gain their membership to gain more requests from clients.",
    },
    {
        title: "Ecommerce Shop",
        laptopImage: image2,
        image: clotheShop,
        link: "https://clotheshopotara.netlify.app/",
        description: "Ecommerce website for high income. It can be changed on any kind of cloth, food, drink etc.",
    },
    {
        title: "Car Shop",
        laptopImage: image3,
        image: carShop,
        link: "https://carshopotara.netlify.app/",
        description: "Website is made for car buying and selling. Dealer can sell or buy cars with 1 on 1 change with customers or he can make the market. Market gives the pr management for owner of website.",
    },
    {
        title: "Constructor",
        laptopImage: image4,
        image: constructor,
        link: "https://constructorotara.netlify.app/",
        description: "Website is made for builder companies. Company can show their projects with images and describe them. It is landing page.",
    },
]
